import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as BoxCountModule from "@/redux/modules/api/data/boxCount/boxCount.module";
import * as BoxCountSelectors from "@/redux/modules/api/data/boxCount/boxCount.selectors";
import { CounterDirections, CounterTheme } from "@/utils/enums";

import BoxCounter from "./boxCounter.component";
import { TextSize } from "./boxCounter.config";

type Props = {
    sku: string;
    maxValue: string;
    direction: string;
    textSize: TextSize;
    theme: CounterTheme;
};

const BoxCounterContainer = ({
    sku,
    maxValue,
    direction,
    textSize,
    theme = CounterTheme.DARK
}: Props) => {
    const boxCount = useSelector(BoxCountSelectors.getBoxCount(sku));
    const dispatch = useThunkDispatch();

    const startingValue =
        direction === CounterDirections.DOWN ? parseInt(maxValue, 10) : 0;
    const value = !Number.isNaN(Number(boxCount))
        ? Number(boxCount)
        : startingValue;

    const startPolling = () => {
        setInterval(() => dispatch(BoxCountModule.load(sku, true)), 30000);
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (sku) {
            dispatch(BoxCountModule.load(sku, true));
            startPolling();
        }
    }, [sku]);

    return (
        <BoxCounter
            length={maxValue.length}
            currentValue={value}
            textSize={textSize}
            theme={theme}
        />
    );
};

export { BoxCounterContainer };
